import { createContext } from "react";
import { CalendarBetaProps } from "./Calendar";

export const CalendarBetaPropsContext = createContext<CalendarBetaProps>({});
